import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IEdenMessageDetails } from "../../../api/IEdenMessage";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import {
  GetActionOrInstructionDetailsPageUrl,
  GetComplianceInvestigationDetailsPageUrl,
  GetEpaCorrespondenceDetailsPageUrl,
  GetLicenseeReturnPageUrl,
  GetSiteVisitDetailsPageUrl,
  GetSiteVisitFindingAndRecommendationsDetailsPageUrl,
} from "../../routeFactory";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  edenMessage: IEdenMessageDetails;
}

const BreadCrumbs = ({ licenceProfile, edenMessage }: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        {edenMessage.siteVisit && (
          <Breadcrumb.Item
            href={GetSiteVisitDetailsPageUrl(
              licenceProfile.profileNo,
              edenMessage.siteVisit.sitevisitid
            )}
          >
            {edenMessage.siteVisit.reference}
          </Breadcrumb.Item>
        )}
        {edenMessage.complianceInvestigationDetails && (
          <Breadcrumb.Item
            href={GetComplianceInvestigationDetailsPageUrl(
              licenceProfile.profileNo,
              edenMessage.complianceInvestigationDetails
                .complianceinvestigationid
            )}
          >
            {edenMessage.complianceInvestigationDetails.reference}
          </Breadcrumb.Item>
        )}
        {edenMessage.licenseeReturn && (
          <Breadcrumb.Item
            href={GetLicenseeReturnPageUrl(
              licenceProfile.profileNo,
              edenMessage.licenseeReturn.licenseereturnid
            )}
          >
            {edenMessage.licenseeReturn.reference}
          </Breadcrumb.Item>
        )}
        {edenMessage.epaCorrespondenceDetails && (
          <Breadcrumb.Item
            href={GetEpaCorrespondenceDetailsPageUrl(
              licenceProfile.profileNo,
              edenMessage.epaCorrespondenceDetails.epainitiatedcorrespondenceid
            )}
          >
            {"EPA Initiated Correspondence"}
          </Breadcrumb.Item>
        )}
        {edenMessage.findingAndRecommendation && (
          <Breadcrumb.Item
            href={GetSiteVisitFindingAndRecommendationsDetailsPageUrl(
              licenceProfile.profileNo,
              edenMessage.findingAndRecommendation.taskid
            )}
          >
            {edenMessage.findingAndRecommendation.reference}
          </Breadcrumb.Item>
        )}
        {edenMessage.actionOrInstructionDetails && (
          <Breadcrumb.Item
            href={GetActionOrInstructionDetailsPageUrl(
              licenceProfile.profileNo,
              edenMessage.actionOrInstructionDetails.taskid
            )}
          >
            {edenMessage.actionOrInstructionDetails.reference}
          </Breadcrumb.Item>
        )}
        <Breadcrumb.Item active>{edenMessage.reference}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
